import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import '@/assets/styles/shared.scss';
import '@/assets/styles/bootstrap.css';
import 'tayeh-ui/dist/index.min.css'
import TayehUi from 'tayeh-ui/dist/index.es.min.js'
import './element-variables.scss';
import { Message, MessageBox } from 'element-ui'
import VueGtag from "vue-gtag";
// import Hotjar from 'vue-hotjar';


Vue.config.productionTip = false
// Vue.use(Swiper)
Vue.use(TayehUi)
function format (valString: string) {
	const val = valString.toString();
	return val.replace(/\B(?=(?:\d{3})+(?!\d))/g, ',')
}
Vue.filter('currency', function (value: any) {
  return (value || value === 0)
    ? format(''+value)
    : ''
})
// Vue.use(TayehUi.currency)
Vue.component('el-menu', () => import(/* webpackChunkName: "el-menu" */ 'element-ui/lib/menu'));
Vue.component('el-submenu', () => import(/* webpackChunkName: "el-submenu" */ 'element-ui/lib/submenu'));
Vue.component('el-menu-item', () => import(/* webpackChunkName: "el-menu-item" */ 'element-ui/lib/menu-item'));
Vue.component('el-upload', () => import(/* webpackChunkName: "el-upload" */ 'element-ui/lib/upload'));
Vue.component('el-pagination', () => import(/* webpackChunkName: "el-pagination" */ 'element-ui/lib/pagination'));
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$alert = MessageBox.alert;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueGtag, {
  config: { id: "G-LD7Z4C6504" },
  appName: 'Tayeh Web',
  pageTrackerScreenviewEnabled: true,
});